import React, { useEffect } from "react";
import { Pagination } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Wrapper from "~/shared/ui/Wrapper";
import { useGetLogsCron } from "~/entity/Logs";
import { useGetLocationData } from "~/hooks/locationData";
import { usePaginationParams } from "~/shared/hooks/usePaginationParams";
import { getTypedDate } from "~/shared/lib/DateFormat/dateFormat";
import { TableV2 } from "~/shared/ui/TableV2";

import IntegrationsLogsFilter from "./Filter";
import { dateFormater } from "./helper";
import { INTEGRATIONS_LOGS } from "./options";

const IntegrationsLogs = () => {
  const { data, getCronParams, isLoading } = useGetLogsCron();
  const { t } = useTranslation();
  const history = useHistory();
  const { count, page } = useGetLocationData();
  // Ключи фильтров приходят из URL и не описаны в типе useGetLocationData
  const { name, start, end } = useGetLocationData() as Record<string, unknown>;

  useEffect(() => {
    getCronParams({
      page,
      count,
      ...(name && { name: String(name) }),
      ...(start && {
        start: getTypedDate({ date: new Date(String(start)), type: "start" }),
      }),
      ...(end && {
        end: getTypedDate({ date: new Date(String(end)), type: "end" }),
      }),
    });
    // getCronParams нестабилен (пересоздаётся в хуке на каждый рендер),
    // поэтому в зависимости не включён — как в исходной версии страницы.
  }, [count, page, name, start, end]);

  const goBack = () => {
    history.replace("/logs/");
  };

  const { handleCount, handlePage } = usePaginationParams();

  return (
    <Wrapper.Content
      title={t("logs.integrations")}
      goBackHandler={goBack}
      txtBtn={t("ui.back")}
      filterComponent={<IntegrationsLogsFilter />}
    >
      <TableV2
        options={INTEGRATIONS_LOGS}
        dataSource={data ? dateFormater(data.items) : []}
        loading={isLoading}
        type="logs.integration"
      />
      <Pagination
        count={count}
        page={page + 1}
        totalCount={data?.total ?? 1}
        onChangeCount={handleCount}
        onChangePage={handlePage}
      />
    </Wrapper.Content>
  );
};

export default IntegrationsLogs;
